import { ApiService } from 'services';

/* eslint-disable-next-line */
export function redirectToApi(path) {
  const url = ApiService.getBaseApiUrl();

  if (url && path) {
    const location = url.slice(0, -4) + path;
    window.location = location;
  }
}
